export default __webpack_public_path__ + "static/media/wave_2732x300.ae6227b4.png";